export default __webpack_public_path__ + "static/media/pdf_icon.7e0c3418.png";